
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.09 8.881V7.515c7.157 0 12.98 5.823 12.98 12.98h-1.366c0-6.404-5.21-11.614-11.614-11.614zm.683-7.515V0c10.924 0 19.812 8.888 19.812 19.812H38.22c0-10.17-8.275-18.446-18.446-18.446zm18.24 31.263l-4.738 4.738c-.59.591-1.474.89-2.624.89-4.356 0-11.137-4.18-18.14-11.184C1.12 15.68.114 8.414 2.218 6.31l4.738-4.738a.702.702 0 01.995 0l4.901 4.902a.696.696 0 01.206.497.697.697 0 01-.206.497l-3.794 3.794v.283c0 4.858 4.42 9.28 7.062 11.92 2.641 2.642 7.062 7.062 11.92 7.062h.283l3.794-3.794a.717.717 0 01.994 0l4.901 4.901a.698.698 0 010 .995zm-3.935-6.862c-.782-.782-2.147-.783-2.927 0l-3.389 3.39c-4.193-.175-8.238-4.22-10.676-6.658-2.438-2.438-6.483-6.483-6.656-10.677l3.388-3.387c.391-.39.606-.91.606-1.464 0-.554-.215-1.073-.606-1.464l-4.9-4.9c-.783-.783-2.146-.783-2.928 0L1.252 5.343C-1.735 8.33.213 16.707 11.545 28.04c7.361 7.363 14.325 11.584 19.106 11.584 1.504 0 2.745-.445 3.59-1.29l4.737-4.738c.391-.39.607-.91.607-1.464 0-.552-.216-1.073-.607-1.463l-4.9-4.9z","fill":"#005149","fill-rule":"evenodd"}})])
          )
        }
      }
    